interface HeaderLogoProps {
  logoUrl?: string;
  onLogoClick: () => void;
  textColor?: string;
}

export function HeaderLogo({ logoUrl, onLogoClick }: HeaderLogoProps) {
  return (
    <div className="flex-shrink-0">
      <button
        onClick={onLogoClick}
        className="focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md"
        aria-label="Go to home page"
      >
          <img
              src={logoUrl}
              alt="Company Logo"
              className="h-10 w-auto"
          />
      </button>
    </div>
  );
}
